export const FA_EXCLAMATION_CIRCLE = [
    'fal',
    'exclamation-circle'
];
export const FA_CHECK = ['far', 'check'];
export const FA_SPINNER = ['far', 'spinner'];
export const FA_TIMES = ['far', 'times'];
export const FA_ARROW_UP = ['fas', 'arrow-up'];
export const FA_CHEVRON_RIGHT = ['far', 'chevron-right'];
